import React from 'react';
import { MapPin, Store, ImageOff, Clock } from 'lucide-react';

const TIME_SLOT_LABEL = {
  morning: '上午',
  afternoon: '下午',
  evening: '晚上'
};

const OrderDeliveryInfo = ({ order }) => {
  if (order.delivery_type === 'pickup') {
    if (!order.store_name) return null;
    return (
      <div className="flex items-center space-x-2 text-sm">
        <Store className="w-4 h-4 text-gray-400 flex-shrink-0" />
        <span className="text-gray-600">自提门店：{order.store_name}</span>
      </div>
    );
  }

  if (!order.delivery_address) return null;

  const mapUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + order.delivery_latitude + ',' + order.delivery_longitude;
  const timeSlotLabel = order.delivery_time_slot ? TIME_SLOT_LABEL[order.delivery_time_slot] : null;
  // delivery_date 是 'YYYY-MM-DD' 或 MySQL 返回的 Date 对象，统一格式化成"8月14日"这种展示形式
  const formatScheduleDate = (dateVal) => {
    if (!dateVal) return null;
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return null;
    return `${d.getMonth() + 1}月${d.getDate()}日`;
  };
  const scheduleDateLabel = formatScheduleDate(order.delivery_date);

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-gray-700">配送信息</p>
        {order.delivery_latitude && order.delivery_longitude && (
          <a href={mapUrl} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-xs text-blue-600 hover:underline flex items-center gap-1">
            <MapPin className="w-3 h-3" />
            导航
          </a>
        )}
      </div>

      <div className="flex items-start space-x-2 text-sm">
        <MapPin className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" />
        <span className="text-gray-600">{order.delivery_address}</span>
      </div>

      {/* 预约送达日期+时段：之前只显示时段，没有日期，现在两者一起展示 */}
      {timeSlotLabel && (
        <div className="flex items-center space-x-2 text-sm">
          <Clock className="w-4 h-4 text-gray-400 flex-shrink-0" />
          <span className="text-gray-600">
            期望送达：
            <span className="font-medium text-gray-800">
              {scheduleDateLabel ? `${scheduleDateLabel} ${timeSlotLabel}` : timeSlotLabel}
            </span>
          </span>
        </div>
      )}

      {(order.customer_name || order.customer_phone) && (
        <div className="flex items-center space-x-4 text-sm text-gray-600">
          {order.customer_name && <span>联系人：{order.customer_name}</span>}
          {order.customer_phone && (
            <a href={'tel:' + order.customer_phone} onClick={e => e.stopPropagation()} className="text-blue-600 hover:underline">
              {order.customer_phone}
            </a>
          )}
        </div>
      )}

      <div>
        <p className="text-xs text-gray-500 mb-1">门牌照片</p>
        {order.door_photo ? (
          <img
            src={order.door_photo}
            alt="门牌"
            className="w-24 h-20 object-cover rounded-lg border border-gray-200 cursor-pointer"
            onClick={e => { e.stopPropagation(); window.open(order.door_photo, '_blank'); }}
          />
        ) : (
          // 门牌照片现在H5端是必填了，但存量老订单可能没有这张照片——
          // 不再直接隐藏这一块（容易让店员以为页面出bug），改成明确提示"没有"
          <div className="w-24 h-20 flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 text-gray-400">
            <ImageOff className="w-5 h-5 mb-1" />
            <span className="text-[11px]">无门牌照片</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderDeliveryInfo;